export const globalConfig = {
  maxFileUpload: 50,
};

export const dateFormat = 'MMM dd, yyyy';
export const dateFormatTime = 'MMM dd, yyyy hh:mm:aa';

export const uploadsErrorMessage = `Only JPEG, JPG, and PNG files are allowed, with a maximum file size of ${globalConfig.maxFileUpload}MB`;
